import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-air-service-banner',
    templateUrl: './air-service-banner.component.html',
    styleUrls: ['./air-service-banner.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AirServiceBannerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
